import { MantineThemeOverride } from '@mantine/core';

export type ThemeIconTheme = NonNullable<MantineThemeOverride['components']>['ThemeIcon'];

export const ThemeIcon: ThemeIconTheme = {
  // todo: define
};
